export default __webpack_public_path__ + "9a5b38861bfdb95bbb5d094eff886f85.woff2";